module.exports = __webpack_public_path__ + "img/prosecution.4c99d7f0.svg";